import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin } from 'antd';

// 受保护的路由组件
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  // 如果正在加载，显示加载指示器
  if (loading) {
    return (
      <Spin size="large" tip="加载中..." spinning={true}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />
      </Spin>
    );
  }

  // 如果用户未登录，重定向到登录页面
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果需要管理员权限但用户不是管理员，重定向到首页
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  // 用户已登录且满足权限要求，渲染子组件
  return children;
};

export default ProtectedRoute; 